import { IPractice } from '@principle-theorem/principle-core/interfaces';
import { DocumentReference } from '@principle-theorem/shared';
import moment from 'moment-timezone';
import {
  getBaseHealthFundCampaignTemplate,
  getNextCampaignStartDate,
} from './health-fund-expiring-calendar-year-campaign-template';
import { IMarketingCampaignTemplate } from './marketing-campaign-template';

export function getHealthFundExpiringFinancialYearCampaignTemplate(
  practiceRef: DocumentReference<IPractice>
): IMarketingCampaignTemplate {
  const nextRunDate = getNextCampaignStartDate({ month: 5, day: 1 });
  const expiryDate = moment(nextRunDate).add(2, 'months');
  const template = getBaseHealthFundCampaignTemplate(
    practiceRef,
    nextRunDate,
    expiryDate
  );

  return {
    ...template,
    name: 'Health Fund Expiring Benefits Financial Year Campaign',
    description: `Remind your patients to use their expiring health fund benefits before the end of the financial year with timely SMS and email reminders.`,
  };
}
